module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/post-office-report/post-office-report.component.css
// module id = ./src/app/admin/components/post-office-report/post-office-report.component.css
// module chunks = main